/*
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-03 16:29:00
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/Index'
import IndexBefor from '@/components/IndexBefor'
import edit from '@/components/Edit'
import editCode from '@/components/EditCode'
import Questionnaire from '@/components/Questionnaire'
import edit1 from '@/components/Edit1'
import history from '@/components/htistory'
import AdmissionNotice from '@/components/AdmissionNotice'
import view from '@/components/View'

Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'IndexBefor',
      component: IndexBefor
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/edit',
      name: 'edit',
      component: edit
    },
    {
      path: '/editCode',
      name: 'editCode',
      component: editCode
    },
    {
      path: '/Questionnaire',
      name: 'Questionnaire',
      component: Questionnaire
    },
    {
      path: '/edit1',
      name: 'edit1',
      component: edit1
    },
    {
      path: '/AdmissionNotice',
      name: 'AdmissionNotice',
      component: AdmissionNotice
    },
    {
      path: '/history',
      name: 'history',
      component: history
    },
    {
      path: '/view',
      name: 'view',
      component: view
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js